export const ACTION_TYPES = {
  ADD_EMPLOYEE: "ADD_EMPLOYEE",
  EDIT_EMPLOYEE: "EDIT_EMPLOYEE",
  DELETE_EMPLOYEE: "DELETE_EMPLOYEE",
  BLOCK_EMPLOYEE: "BLOCK_EMPLOYEE",
  MIGRATE_EMPLOYEE: "MIGRATE_EMPLOYEE",
  ADD_LEGAL_EMPLOYEE: "ADD_LEGAL_EMPLOYEE",
  EDIT_LEGAL_EMPLOYEE: "EDIT_LEGAL_EMPLOYEE",
  DELETE_LEGAL_EMPLOYEE: "DELETE_LEGAL_EMPLOYEE",
  BLOCK_LEGAL_EMPLOYEE: "BLOCK_LEGAL_EMPLOYEE",
  CHANGE_RATES: "CHANGE_RATES",
  CANCEL_RATES: "CANCEL_RATES",
  ADD_BRANCH: "ADD_BRANCH",
  EDIT_BRANCH: "EDIT_BRANCH",
  DELETE_BRANCH: "DELETE_BRANCH",
  HIDE_BRANCH: "HIDE_BRANCH",
  PUSH_BANK_TRANSFER: "PUSH_BANK_TRANSFER",
  PUSH_BULK_BANK_TRANSFER: "PUSH_BULK_BANK_TRANSFER",
  PUSH_S2S_TRANSFER: "PUSH_S2S_TRANSFER",
  PUSH_S2B_TRANSFER: "PUSH_S2B_TRANSFER",
  PUSH_BULK_S2S_TRANSFER: "PUSH_BULK_S2S_TRANSFER",
  INITIATE_EXCHANGE: "INITIATE_EXCHANGE",
  CONFIRM_INITIATE_TRANSFER: "CONFIRM_INITIATE_TRANSFER",
  APPROVE_TRX: "APPROVE_TRX",
  APPROVE_LIST_TRX: "APPROVE_LIST_TRX",
  MANAGE_AUTO_CONVERSION: "MANAGE_AUTO_CONVERSION",
  EDIT_MERCHANT_INFO: "EDIT_MERCHANT_INFO",
  EDIT_EMPLOYEE_LIMITATION: "EDIT_EMPLOYEE_LIMITATION",
  INITIATE_PAYMENT_REQUEST: "INITIATE_PAYMENT_REQUEST",
  INITIATE_BULK_PAYMENT_REQUEST: "INITIATE_BULK_PAYMENT_REQUEST",
  REQUEST_CARD: "REQUEST_CARD",
  EDIT_CARD: "EDIT_CARD",
  ACTIVATE_DEACTIVATE_CARD: "ACTIVATE_DEACTIVATE_CARD",
  CANCEL_CARD: "CANCEL_CARD",
  REVERSE_TRANSACTION: "REVERSE_TRANSACTION",
  SUBMIT_PAYROLL: "SUBMIT_PAYROLL",
  PUSH_PAYROLL_ADVANCE_LIST: "PUSH_PAYROLL_ADVANCE_LIST",
  REPLACE_PAYROLL_ADVANCE_LIST: "REPLACE_PAYROLL_ADVANCE_LIST",
  APPROVE_QUICK_PAY: "APPROVE_QUICK_PAY",
  APPROVE_QUICK_PAY_MOBILE: "APPROVE_QUICK_PAY_MOBILE",
  EDIT_USER_PAYROLL_ADVANCE: "EDIT_USER_PAYROLL_ADVANCE",
  CONFIRM_EMPLOYEE: "CONFIRM_EMPLOYEE",
  CONFIRM_PAYROLL: "CONFIRM_PAYROLL",
  PAY_SINGLE_PAYROLL: "PAY_SINGLE_PAYROLL",
  DELETE_PAYROLL: "DELETE_PAYROLL",
  DELETE_PAYROLL_MOBILE: "DELETE_PAYROLL_MOBILE",
  NEW_CASHOUT_ORDER: "NEW_CASHOUT_ORDER",
  NEW_CASHIN_ORDER: "NEW_CASHIN_ORDER",
  APPROVE_PAYROLL: "APPROVE_PAYROLL",
  APPROVE_PAYROLL_MOBILE: "APPROVE_PAYROLL_MOBILE",
  REJECT_PAYROLL: "REJECT_PAYROLL",
  REJECT_PAYROLL_MOBILE: "REJECT_PAYROLL_MOBILE",
  CREATE_NEW_ROLE: "CREATE_NEW_ROLE",
  QR_BILL: "QR_BILL",
  PAY_ALFA_PREPAID: "PAY_ALFA_PREPAID",
  PAY_ALFA_POSDPAID: "PAY_ALFA_POSDPAID",
  PAY_TOUCH_POSTPAID: "PAY_TOUCH_POSTPAID",
  PAY_TOUCH_PREPAID: "PAY_TOUCH_PREPAID",
  PAY_OGERO_PREPAID: "PAY_OGERO_PREPAID",
  PAY_TERRANET_LANDLINE: "PAY_TERRANET_LANDLINE",
  REFILL_SODETEL: "REFILL_SODETEL",
  DOWNLOAD_SOA_PDF: "DOWNLOAD_SOA_PDF",
  EXPORT_PAYROLL_RECEIPTS: "EXPORT_PAYROLL_RECEIPTS",
  GENERATE_REPORT: "GENERATE_REPORT",
  DELETE_REPORT: "DELETE_REPORT",
  RESEND_REPORT: "RESEND_REPORT",
  UPDATE_REPORT: "UPDATE_REPORT",
  PURCHASE_ESIM: "PURCHASE_ESIM",
  DISABLE_ALL_PAYROLL_ADVANCE: "DISABLE_ALL_PAYROLL_ADVANCE",
  TO_STATUS_USER_PAYROLL_ADVANCE: "TO_STATUS_USER_PAYROLL_ADVANCE",
  DELETE_USER_PAYROLL_ADVANCE: "DELETE_USER_PAYROLL_ADVANCE",
  UPLOAD_BASE_SALARY: "UPLOAD_BASE_SALARY",
  PUSH_QUICK_PAY: "PUSH_QUICK_PAY",
  DELETE_PENDING_APPROVAL_QUICK_PAY: "DELETE_PENDING_APPROVAL_QUICK_PAY",
  DELETE_ACTIVE_QUICK_PAY: "DELETE_ACTIVE_QUICK_PAY",
  DELETE_SINGLE_USER_QUICK_PAY: "DELETE_SINGLE_USER_QUICK_PAY",
  EDIT_SINGLE_USER_QUICK_PAY: "EDIT_SINGLE_USER_QUICK_PAY",
  UPLOAD_NEW_QUICK_PAY_EMPLOYEES: "UPLOAD_NEW_QUICK_PAY_EMPLOYEES",
  CREATE_QUICK_PAY_REQUEST: "CREATE_QUICK_PAY_REQUEST",
  PUSH_NEW_QUICK_PAY_EMPLOYEES: "PUSH_NEW_QUICK_PAY_EMPLOYEES",
  UPDATE_EMPLOYEE_LOAN_ELIGILIBILITY: "UPDATE_EMPLOYEE_LOAN_ELIGILIBILITY",
  GENERATE_CASH_DEPOSIT_CODE: "GENERATE_CASH_DEPOSIT_CODE",
  UPDATE_AUTOMATIC_BILL_PAYMENT: "UPDATE_AUTOMATIC_BILL_PAYMENT",
  CANCEL_REQUEST_TO_PAY: "CANCEL_REQUEST_TO_PAY",
  EXECUTE_COMPANY_TRANSFER: "EXECUTE_COMPANY_TRANSFER",
  EXECUTE_INTERNATIONAL_TRANSFER: "EXECUTE_INTERNATIONAL_TRANSFER",
  CANCEL_PAYROLL: "CANCEL_PAYROLL",
  ACTION_EMPLOYEES_OVERVIEW: "ACTION_EMPLOYEES_OVERVIEW",
  PUSH_OUTWARD_TRANSFER: "PUSH_OUTWARD_TRANSFER",
  SAVE_MODIFICATION_REQUEST: "SAVE_MODIFICATION_REQUEST",
  SAVE_CORPORATE_TVA_DATA: "SAVE_CORPORATE_TVA_DATA",
};
